import { queryOptions, useQuery } from "@tanstack/react-query";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";

import type { QueryConfig } from "@/lib/react-query";
import type { Garage } from "@/types/garage";

export const getGarage = async ({ garageId }: { garageId: string }): Promise<Garage> => {
  return (await api.get(`/carburate/garages/${garageId}/`)) as Garage;
};

export const getGarageQueryOptions = (garageId: string) => {
  return queryOptions({
    queryKey: ["garages", garageId],
    queryFn: () => getGarage({ garageId }),
    staleTime: 0,
    gcTime: 0,
  });
};

type UseGarageOptions = {
  garageId: string;
  queryConfig?: QueryConfig<typeof getGarage>;
};

export const useGarage = ({ garageId, queryConfig }: UseGarageOptions) => {
  return useQuery({
    enabled: hasAccessToken(),
    ...getGarageQueryOptions(garageId),
    refetchOnWindowFocus: true,
    refetchOnMount: "always",
    refetchInterval: 5000,
    refetchIntervalInBackground: true,
    staleTime: 0,
    ...queryConfig,
  });
};
